import Cookies from 'universal-cookie';
import syncRequest from 'sync-request';

const COOKIE_OPTIONS = {
    path: '/',
    domain: window.location.hostname,
    secure: window.location.protocol === 'https:',
    sameSite: 'lax'
};

/**
 * Cookie 있는지 여부
 */
export function hasCookie() {
    const cookies = new Cookies();
    let beaconToken = cookies.get('beacon_token');
    if( beaconToken == null ){
        cookies.remove('beacon_token', COOKIE_OPTIONS);
        return false;
    } else {
        return true;
    }
}

/**
 * Cookie Validation
 */
export function isCookieValidate() {
    const cookies = new Cookies();
    let response = syncRequest('GET', '/api/v1/auth/valid', setHeaders());
    if( response != null && response.statusCode === 200 ){
        let responseBody = JSON.parse(response.getBody('utf8'));
        if( responseBody != null ){
            return responseBody.data;
        }
    } else {
        cookies.remove('beacon_token', COOKIE_OPTIONS);
        return false;
    }
}

/**
 * cookie 값으로 해더 셋팅
 */
export function setHeaders(){
    const cookies = new Cookies();
    let beaconToken = cookies.get('beacon_token');
    return { headers: {"Authorization" : `Bearer ${beaconToken}`}};
}

export function setHeader(){
    const cookies = new Cookies();
    let beaconToken = cookies.get('beacon_token');
    return {"Authorization" : `Bearer ${beaconToken}`};
}

export function removeCookie() {
    const cookies = new Cookies();
    // 모든 가능한 옵션으로 쿠키 삭제 시도
    cookies.remove('beacon_token', { path: '/' });
    cookies.remove('beacon_token', { path: '/', domain: window.location.hostname });
    cookies.remove('beacon_token', { path: '/', domain: '.' + window.location.hostname });
    
    // 쿠키가 제대로 삭제되었는지 확인
    if (cookies.get('beacon_token')) {
        console.error('Cookie was not removed properly');
    }
    
    // 페이지 리다이렉트
    window.location.href = '/app/login';
}


// WEBPACK FOOTER //
// ./src/services/Cookie/CookieService.js